import { useMutation } from "@tanstack/react-query";
import storageService from "src/queries/services/storage";

export const useUploadDirectToStorage = (accountId, assistantId) => useMutation({
  mutationFn: ({ file, files }) => {
    if (files && Array.isArray(files)) {
      return storageService.uploadDirectToStorage(accountId, assistantId, files);
    }
    return storageService.uploadDirectToStorage(accountId, assistantId, file);
  }
});

export const useGetFileFromStorage = (accountId, assistantId) => useMutation({
  mutationFn: ({ filePath, fileName }) =>
    storageService.getFileFromStorage(accountId, assistantId, filePath, fileName)
});

export default {
  useUploadDirectToStorage,
  useGetFileFromStorage
};
